module.exports = __webpack_public_path__ + "img/chinesecompany164.b43c615b.png";